import { useContext } from 'react';
import { BreakpointsContext } from '@cvent/carina/components/Breakpoints/BreakpointsProvider';
/**
 * Simple hook for getting breakpoint data from BreakpointsContext
 * https://carina-dev.core.cvent.org/components/breakpoints
 */
const useBreakpoints = () => {
    const breakpoints = useContext(BreakpointsContext);
    return Object.assign(Object.assign({}, breakpoints), { isMobile: breakpoints.isDefaultSize || breakpoints.isS, 
        // @ts-expect-error Object is possibly undefined
        isLandscapeMobile: breakpoints.widthWindow < 680 && breakpoints.widthWindow > 515, isDesktop: breakpoints.isM || breakpoints.isL || breakpoints.isXL, isMobileOrTablet: breakpoints.isDefaultSize || breakpoints.isS || breakpoints.isM });
};
export default useBreakpoints;
//# sourceMappingURL=useBreakpoints.js.map